import { render, staticRenderFns } from "./selectTipoCliente.vue?vue&type=template&id=3555282c&"
import script from "./selectTipoCliente.vue?vue&type=script&lang=js&"
export * from "./selectTipoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports